import React from "react";

const useMediaQuery = (query: string) => {
  const [matches, $matches] = React.useState(false);

  React.useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      $matches(media.matches);
    }
    const listener = () => $matches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
